import React, { useEffect, useState } from "react";
import useDataSession from "../../customeHooks/useDataSession";
import useCoreAgora from "../../../../general/customHooks/coreAgora";
import { classNames } from "../../../../general/functions/propsComponent";
import VideoPlayer from "../../../../general/components/VideoUser/VideoPlayer";
import { checkVoulumeLevel } from "../../../../general/functions/agoraCustomeFunctions";
import AssesseeControls from "../molekuls/AssesseeControls";
import GuideAssessee from "../molekuls/GuideAssessee";
import HeaderOnSesssion from "../molekuls/HeaderOnSesssion";
import useRoomAgora from "../../customeHooks/useRoomAgora";
import useInfoAssessorLeave from "../../customeHooks/useInfoAssessorLeave";
export default function PresentasiAssesseeView() {
  const { selfUid, session, listUser, dataSession } = useDataSession();
  console.log("useDataSession", selfUid, session, dataSession, listUser);
  const [showGuide, setShowGuide] = useState(false);
  const [listUserData, setListUserData] = useState([]);
  const {
    usersJoin,
    usersVolume,
    isConnect,
    isSelfTracksReady,
    selfTracks,
    isMuteTrackSelf,
    isShareScreen,
    setJoin,
    setMuteSelfTracks,
    setSchareScreen,
    setShareScreenUid,
    errorInfo,
    stats,
  } = useCoreAgora({
    uid: parseInt(selfUid),
    channelName: session,
  });
  useInfoAssessorLeave({ listUserData: listUserData });

  const { handleLeaveAlone } = useRoomAgora({ setJoin });

  useEffect(() => {
    setJoin(true);
  }, []);
  useEffect(() => {
    if (isConnect) {
      // setMuteSelfTracks("audio", false);
      setMuteSelfTracks("video", false);
    }
  }, [isConnect]);

  useEffect(() => {
    console.log("aasessee testing listUser", listUser);
    let tmp = listUser?.map((x) => {
      let dTmp = usersJoin.find((y) => y.uid == x.uId);

      if (dTmp != undefined) {
        x.agora = dTmp;
      } else {
        x.agora = null;
      }
      return x;
    });
    let uidShareScreen = tmp?.find(
      (y) => y?.agora == null && y.type == "SHARESCREEN"
    );
    setShareScreenUid(
      uidShareScreen?.uId != undefined ? uidShareScreen?.uId : null
    );
    setListUserData(tmp);
  }, [usersJoin, listUser]);

  let screenShareAvailable =
    listUserData?.find((x) => x.type == "SHARESCREEN")?.agora?.agoraDetail !=
    null;
  let recordingIsAvailable =
    listUserData?.find((x) => x.type == "RECORDING")?.agora?.agoraDetail !=
    null;
  let positionVideoList =
    listUserData?.filter((x) => x.type != "RECORDING" && x?.agora != null)
      .length >= 4;
  let ListAssessorByPosition = listUserData
    ?.sort((a, b) => {
      let na = 0;
      let nb = 0;
      if (a?.isMuteTrackSelf?.video) {
        na += 1;
      }
      if (a?.isMuteTrackSelf?.audio) {
        na += 2;
      }
      if (b?.isMuteTrackSelf?.video) {
        nb += 1;
      }
      if (b?.isMuteTrackSelf?.audio) {
        nb += 2;
      }
      if (na > nb) {
        return 1;
      }
      if (na < nb) {
        return -1;
      }
    })
    ?.filter((x) => x.type == "ASSESSOR" && x?.agora != null);
  return (
    <>
      <div
        className=" h-full flex w-full overflow-hidden"
        style={{ height: "92vh", maxWidth: "100vw", minHeight: "720px" }}
      >
        <div className={classNames("w-full h-full  mx-auto  ")}>
          <HeaderOnSesssion
            title={"INTERVIEW | " + dataSession.sessionInfo?.sessionTitle}
            sub={"Assessee View "}
          />

          {screenShareAvailable ? (
            <div
              className=" flex justify-center items-center pt-4  w-full"
              style={{
                height: screenShareAvailable ? "75%" : "65%",
              }}
            >
              <div
                className="aspect-video  flex  items-center justify-center "
                style={{ width: "100%", maxHeight: "100%" }}
              >
                <VideoShareScreen
                  shareScreen={listUserData.find(
                    (x) => x.type == "SHARESCREEN"
                  )}
                  usersVolume={usersVolume}
                />
              </div>
            </div>
          ) : (
            <div
              className={classNames(
                " flex gap-2 mt-2  overflow-auto p-2 ",
                positionVideoList ? "" : "justify-center"
              )}
              style={{
                height: "50%",
                width: "100%",
              }}
            >
              {selfTracks && isConnect && (
                <VideoMain
                  users={ListAssessorByPosition}
                  userSelf={{ ...dataSession?.user, isMuteTrackSelf }}
                  usersVolume={usersVolume}
                  tracks={selfTracks}
                  isShareScreen={screenShareAvailable}
                />
              )}
            </div>
          )}

          <div
            className={classNames(
              " flex gap-2 mt-2  overflow-auto p-2 ",
              positionVideoList ? "" : "justify-center"
            )}
            style={{
              height: screenShareAvailable ? "15%" : "45%",
              width: "100%",
            }}
          >
            {selfTracks && isConnect && (
              <VideoList
                users={ListAssessorByPosition}
                userSelf={{ ...dataSession?.user, isMuteTrackSelf }}
                usersVolume={usersVolume}
                tracks={selfTracks}
                isShareScreen={screenShareAvailable}
              />
            )}
          </div>
        </div>
        {/* Guideline part */}
        <div
          className={classNames(
            // "bg-gray-50 w-64  h-screen flex  transition-transform -translate-x-full",
            "sticky  top-0 max-w-sm  right-0  min-h-screen   bg-gray-100 transition-all duration-100  ease-out",
            // " sticky  max-w-lg top-0 right-0 z-50  h-screen p-4 transition-transform  bg-gray-100 ",
            showGuide
              ? " -translate-x-0 w-full "
              : "translate-x-96 overflow-hidden w-0"
          )}
        >
          {/* <div className=" px-2 pb-32 bg-red-200 overflow-auto h-full "> */}
          <div className="   min-h-[95vh] overflow-auto">
            {/*Mian Content */}
            <GuideAssessee />
            {/* Main Content */}
          </div>
        </div>
        {/* end Guideline Part */}
      </div>

      <div className="h-14"></div>
      {isSelfTracksReady && selfTracks && isConnect && (
        <div className="py-2 px-2 fixed bottom-0 w-full bg-black">
          <AssesseeControls
            tracks={selfTracks}
            tracksState={isMuteTrackSelf}
            isShareScreen={isShareScreen}
            isOtherShareScreen={
              screenShareAvailable == true && isShareScreen == false
            }
            errorInfo={errorInfo}
            setJoin={(v) => {
              handleLeaveAlone(!v);
              setJoin(v);
            }}
            setMute={(v) => {
              setMuteSelfTracks(v?.type, v?.status);
            }}
            setShareScreen={() => {
              setSchareScreen(!isShareScreen);
            }}
            channelName={session}
            setShowGuide={() => {
              setShowGuide(!showGuide);
            }}
            btnAvailable={{
              shareScreen: true,
              guide: dataSession.sessionInfo?.assesseeGuideExist,
              answer: true,
            }}
          />
        </div>
      )}
    </>
  );
}

const VideoShareScreen = (props) => {
  const { shareScreen } = props;
  let videoMain = shareScreen?.agora?.agoraDetail != null ? shareScreen : null;
  console.log("videoMain", videoMain);
  return (
    <>
      {videoMain != null && (
        <div
          className="relative h-full p-0  border border-secondary-300 aspect-video "
          style={{}}
        >
          <VideoPlayer
            videoTrack={videoMain?.agora?.agoraDetail.videoTrack}
            isVideoMute={!videoMain?.agora?.video}
            isMicMute={!videoMain?.agora?.audio}
            title={videoMain?.name}
            uid={videoMain?.uId}
            tagLable={videoMain?.type == "ASSESSOR" ? videoMain?.type : null}
            shareScreen={shareScreen?.agora?.agoraDetail != null ? true : false}
            isSpeak={false}
          />
        </div>
      )}
    </>
  );
};

const VideoMain = (props) => {
  const { users, tracks, userSelf, usersVolume } = props;
  let userShow = users[0];
  return (
    <>
      <div className="flex  gap-1 flex-nowrap  " style={{ height: "100%" }}>
        <VideoPlayer
          videoTrack={tracks[1]}
          isVideoMute={!userSelf.isMuteTrackSelf?.video}
          isMicMute={!userSelf.isMuteTrackSelf?.audio}
          title={userSelf?.name}
          uid={userSelf?.uId}
          tagLable={userSelf?.type == "ASSESSOR" ? userSelf?.type : null}
          isSpeak={checkVoulumeLevel(usersVolume, userSelf?.uId).status}
        />
        {userShow?.agora != null && (
          <VideoPlayer
            videoTrack={userShow?.agora?.agoraDetail?.videoTrack}
            isVideoMute={!userShow?.agora?.video}
            isMicMute={!userShow?.agora?.audio}
            title={userShow?.name}
            uid={userShow?.uId}
            tagLable={userShow?.type == "ASSESSOR" ? userShow?.type : null}
            isSpeak={checkVoulumeLevel(usersVolume, userShow?.uId).status}
          />
        )}
      </div>
    </>
  );
};

const VideoList = (props) => {
  const { users, tracks, userSelf, usersVolume, isShareScreen } = props;

  return (
    <>
      <div className="flex gap-1 flex-nowrap " style={{ height: "100%" }}>
        {isShareScreen == true && (
          <VideoPlayer
            videoTrack={tracks[1]}
            isVideoMute={!userSelf.isMuteTrackSelf?.video}
            isMicMute={!userSelf.isMuteTrackSelf?.audio}
            title={userSelf?.name}
            uid={userSelf?.uId}
            tagLable={userSelf?.type == "ASSESSOR" ? userSelf?.type : null}
            isSpeak={checkVoulumeLevel(usersVolume, userSelf?.uId).status}
          />
        )}

        {users?.map((x, i) => {
          // sharescrin off withoud 1, on with 1
          if (isShareScreen == false && i != 0) {
            return (
              <VideoPlayer
                videoTrack={x.agora?.agoraDetail?.videoTrack}
                isVideoMute={!x.agora?.video}
                isMicMute={!x.agora?.audio}
                title={x?.name}
                uid={x?.uId}
                tagLable={x?.type == "ASSESSOR" ? x?.type : null}
                isSpeak={checkVoulumeLevel(usersVolume, x?.uId).status}
              />
            );
          } else if (isShareScreen == true) {
            return (
              <VideoPlayer
                videoTrack={x.agora?.agoraDetail?.videoTrack}
                isVideoMute={!x.agora?.video}
                isMicMute={!x.agora?.audio}
                title={x?.name}
                uid={x?.uId}
                tagLable={x?.type == "ASSESSOR" ? x?.type : null}
                isSpeak={checkVoulumeLevel(usersVolume, x?.uId).status}
              />
            );
          }
        })}
      </div>
    </>
  );
};
